import $ from 'jquery'
import {Base64} from 'js-base64'

export function changeMainColor(defaultTheme) {
    $(".mainColor").css("color", defaultTheme)
    $(".mainBgColor").css("background", defaultTheme)
    $(".mainBdColor").css("border-color", defaultTheme)
    $(".resetColor").css({"color": "#000000", "background": "transparent"})
    $(".resetBdColor").css({"border-color": "#F7F7F7"})
    $(".resetIconColor").css({"color": "#A6A6A6"})
    $(".whiteColor").css({"color": "#ffffff"})
}

/**
 * 获取页面链接参数
 * @param {*} str 参数名称
 */
export function QueryString(str) {
    var sValue = window.location.href.match(new RegExp("[\?\&]" + str + "=([^\&]*)(\&?)", "i"));
    return sValue ? sValue[1] : sValue;
}

/**
 * 是否有权限
 * @param {*} key
 */
export function hasPermission(key) {
    let arr = JSON.parse(sessionStorage.getItem('permissions') || '[]')
    if (arr.indexOf('*') !== -1 || arr.indexOf(key) !== -1) {
        return true
    } else {
        return false
    }
}

export function hasPermissionButton(key) {
    let arr = JSON.parse(sessionStorage.getItem('permissions') || '[]')
    if (arr.indexOf(key) !== -1) {
        return true
    } else {
        return false
    }
}

/**
 * 表单对象赋值:
 * 对目标对象存在且源对象同样存在的属性，全部覆盖；
 * 目标对象不存在但是源对象存在的属性， 全部丢弃；
 * 目标对象存在但是源对象不存在的属性，如果是字符串赋值为空串，其余类型赋值为undefined
 */
export function recover(target, source) {
    if (target === undefined || target === null) {
        throw new TypeError('Cannot convert first argument to object')
    }
    var to = Object(target)
    if (source === undefined || source === null) {
        return to
    }
    var keysArray = Object.keys(Object(target))
    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
        var nextKey = keysArray[nextIndex]
        var desc = Object.getOwnPropertyDescriptor(target, nextKey)
        if (desc !== undefined && desc.enumerable) {
            if (to[nextKey] instanceof Array) {
                to[nextKey] = source[nextKey] || []
            } else if (to[nextKey] instanceof Object) {
                recover(to[nextKey], source[nextKey])
            } else if (source[nextKey] !== undefined) {
                to[nextKey] = source[nextKey]
            } else if (typeof (to[nextKey]) === 'string') {
                to[nextKey] = ''
            } else {
                to[nextKey] = undefined
            }
        }
    }
    return to
}


// 导出xlxs
export function exportExcel(url, params, fileName, methodType = 'get') {
    let msg = this.$message({
        showClose: true,
        duration: 0,
        message: '正在处理中...',
        type: 'success'
    });
    this.$axios(url, params, methodType).then(res => {
        if (res.code == 500) {
            this.$message(res.msg)
            msg.close()
            return
        }
        this.$axios(url, params, methodType, 'blob').then(response => {
            let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
            let link = document.createElement('a')
            link.download = decodeURI(fileName)
            link.href = window.URL.createObjectURL(blob)
            link.click()
            msg.close()
        }).catch((error) => {

        })
    })
}

// 文件地址下载  type：zip
export function downloadFileUrl(url, fileName, type) {
    if (type == 'zip') {
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    } else {
        const url2 = url.replace(/\\/g, '/');
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url2, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
            if (xhr.status === 200) {
                const urlObject = window.URL || window.webkitURL || window;
                const export_blob = new Blob([xhr.response]);
                const save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
                save_link.href = urlObject.createObjectURL(export_blob);
                save_link.download = fileName;
                save_link.click();
            } else {
                this.$message.error('下载失败')
            }
        };
        xhr.send();
    }
}

export function formatDate(value, type) {
    let date = new Date();
    if(value) {
        date = new Date(value);
    }
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    let m = date.getMinutes();
    m = m < 10 ? ('0' + m) : m;
    let s = date.getSeconds();
    s = s < 10 ? ('0' + s) : s;
    if (type == 0) {
        return y + '' + MM + '' + d;
    } else if (type == 1) {
        return y + '-' + MM + '-' + d;
    } else if (type == 2) {
        return y + '年' + MM + '月' + d + '日';
    } else if (type == 3) {
        return y + '-' + MM + '-' + d + ' ' + '23:59:59'
    } else if (type == 5) {
        return h + ':' + m + ':' + s;
    } else {
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    }
}

// 支持上传的文件格式  type组件类型id, dict字典配置
export function getSupportUploadFileFormat(type, dict) {
    if (type == '23') {
        return ['stl', 'glb', 'zip', '7z', 'rar']
    }
    if (type == '14') {
        return ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'tif', 'zip', '7z', 'rar']
    }
    if (type == '17') {
        return ['mp3', 'ogg', 'm4a', 'flac', 'opus', 'wav', 'wma', 'zip', '7z', 'rar']
    }
    if (type == '15') {
        return ['mp4', 'mkv', 'avi', 'wmv', 'rmvb', '3gp', 'asf', 'swf', 'vob', 'mov', 'm4v', 'flv', 'f4v', 'mts', 'ts', 'zip', '7z', 'rar']
    }
    if (type == '13') {
        return ['pdf', 'docx', 'xlsx', 'txt', 'jpg', 'jpeg', 'png', 'mp4', 'mp3']
    }
    if (dict) {
        return this.$dictUtils.getDictListValue('attachment_type')
    }
}

// 支持预览的文件格式
export function getSupportPreviewFileFormat(type) {
    if (type == '23') {
        return ['stl', 'glb', 'zip', '7z', 'rar']
    }
    if (type == '14') {
        return ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'GIF', 'JPG', 'PNG', 'JPEG', 'BMP']
    }
    if (type == '17') {
        return ['mp3', 'MP3', 'wav', 'WAV', 'm4a', 'M4A']
    }
    if (type == '15') {
        return ['mp4', 'MP4', 'flv', 'FLV', 'mov', 'MOV']
    }
    if (type == '13') {
        return ['pdf', 'PDF', 'docx', 'DOCX', 'xlsx', 'XLSX', 'jpg', 'jpeg', 'JPEG', 'png', 'JPG', 'PNG', 'mp4', 'MP4', 'mp3', 'MP3']
    }
}

/**
 * 时间大小比较:
 * date1 > data2 返回 true 否则返回 false
 */
export function toDateSize(date1, date2) {
    date1 = new Date(date1).getTime()
    date2 = new Date(date2).getTime()
    if (date1 > date2) {
        return true
    } else {
        return false
    }
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
export function handleTree(data, id, parentId, children, rootId) {
    id = id || 'id'
    parentId = parentId || 'parentId'
    children = children || 'children'
    rootId = rootId || Math.min.apply(Math, data.map(item => {
        this.$set(item, 'isSelect', false)
        return item[parentId]
    })) || 0
    //对源数据深度克隆
    const cloneData = JSON.parse(JSON.stringify(data))
    //循环所有项
    const treeData = cloneData.filter(father => {
        let branchArr = cloneData.filter(child => {
            //返回每一项的子级数组
            // console.log(id, father[id], child[parentId], father[id] === child[parentId]);
            return father[id] === child[parentId]
        });
        branchArr.length > 0 ? father.children = branchArr : '';
        //返回第一层
        return father[parentId] === rootId;
    });
    return treeData != '' ? treeData : data;
}

export function getHumpLineName(s) {
    return s.replace(/([A-Z])/g, '_$1').toLowerCase()
}

// 预览地址  url地址，name名称
export async function onlinePreview(url, name) {
    let response
    try {
        response = await this.$axios('zyd-common/tools/getWatermarkFile', {
            inputFile:url,
            resourceName:name,
        })
    } catch (error) {
        throw error;
    }
    let watermarkFile = url
    if(response.status) {
        watermarkFile = response.data
    }
    return this.$pdfPreviewUrl() + 'onlinePreview?url=' + encodeURIComponent(Base64.encode(watermarkFile)).replaceAll("\\+", "%20") + '&resourcesName=' + name
}


/**
 * 文件流下载+接口错误提示
 * @param {*} url 下载api
 * @param {*} params 接口传参
 * @param {*} fileName 下载文件名称
 * @param {*} type 下载类型
 * @param {*} method 接口请求类型
 */
export function fileBlobDownload(url, params = {}, fileName = '', type = '', method = 'post') {
    let msg = this.$message({
        showClose: true,
        duration: 0,
        message: '正在处理中...',
        type: 'success'
    });
    this.$axios(url, params, method, 'blob').then(data => {
        if (data.status == 200 && data.config.responseType == 'blob') {
            if (data.headers['content-type'].includes('json')) {
                let fileReader = new FileReader()
                fileReader.readAsText(data.data)
                fileReader.onload = result => {
                    let jsonData = JSON.parse(result.target.result)
                    this.$message.error(jsonData.msg)
                }
            } else {
                let blob = new Blob([data.data], {type})
                let link = document.createElement('a')
                link.download = decodeURI(fileName)
                link.href = window.URL.createObjectURL(blob)
                link.click()
            }
            msg.close()
        }
    })
}

export default {
    fileBlobDownload,
    downloadFileUrl,
    getSupportUploadFileFormat,
    getSupportPreviewFileFormat,
    hasPermission,
    hasPermissionButton,
    recover,
    exportExcel,
    QueryString,
    changeMainColor,
    formatDate,
    toDateSize,
    handleTree,
    getHumpLineName,
    onlinePreview
}
